import axios from "@/api/axiosInstance";
import { AlgoliaConfigResponse } from "./types";

export const fetchCampaignStatusMetadataAlgoliaConfig =
  async (): Promise<AlgoliaConfigResponse> => {
    const response = await axios.get<AlgoliaConfigResponse>(
      `/api/private/stochastic/campaign-status-metadata/algolia-config`,
    );

    return response.data;
  };
